import EmailHeaderDto, {EmailHeader} from '../services/messages/EmailHeaderDto';
import {ItemContent} from '../domain/ItemContent';
import {OutgoingEmailDto} from '../services/messages/OutgoingEmailDto';
import {AttachmentContentDto} from "../domain/AttachmentContentDto";
import {LocationItemType} from "../actions/EmailActionTypes";
import {AttachmentDto} from "../domain/AttachmentDto";
import {RelativeDateTimeOption} from "../domain/RelativeDateTimeOption";
import {ImageContentDto} from "../domain/ImageContentDto";
import {EmailViewOptions} from "../domain/EmailViewOptions";
import {EmailViewOptionsPref} from "../util/Preferences";
import {ItemChangeListDto} from "../services/messages/ItemChangeListDto";

export const BlankEmailHeaderDto: EmailHeaderDto = {
    AttachmentCount: 0,
    BodySample: "",
    CC: "",
    Category: "",
    CertificateId: null,
    Date: 0,
    DisplayDate: 0,
    DateReceived: undefined,
    Defaulted: false,
    DomainKeyMatchStatus: "",
    Flagged: 0,
    FolderId: 0,
    From: "",
    Id: 0,
    Importance: "",
    LastVerb: "",
    MessageClass: "",
    PendingSecureCount: 0,
    PgpStatus: "",
    Read: 0,
    SendCount: 0,
    SmimeStatus: "",
    SpfMatchStatus: "",
    Subject: "",
    ThreadId: "",
    To: "",
    ShowTrustShield: false,
    Reminder: undefined,
};

export const BlankEmailHeader: EmailHeader = {
    ...BlankEmailHeaderDto,
    IsDummyLoadingRow: false,
    DateRangeCategory: "",
};

export interface SelectedAttachment {
    id: string;
    emailId: number;
}

export interface ItemState {
    emailHeaders: EmailHeader[];
    allEmailHeadersLoaded: boolean;
    itemLoadingInProgress: boolean;
    folderLoadingInProgress: boolean;
    draftEmailHeaders: EmailHeader[];
    selectedGreylistedEmailId?: string;
    mobileSelectionEnabled: boolean;
    selectedEmailHeaders: EmailHeader[];
    selectedOutgoingEmails: OutgoingEmailDto[];

    pendingSyncItems: ItemChangeListDto[],

    availableCategories: string[];
    selectedCategoriesFilter: string[];

    itemId?: number;
    itemIdStr?: string;
    itemType?: LocationItemType;
    itemContentIndex: 0 | 1;
    itemContents: [ItemContent, ItemContent];

    emailViewOptions: EmailViewOptions;

    contentExpanded: boolean;
    isLoadingContent: boolean;
    selectedAttachment?: SelectedAttachment;
    contextAttachment?: AttachmentDto;
    imageContent?: ImageContentDto;
    inlineContent?: AttachmentContentDto;

    editEmailCategory: string;
    showEmailCategoryDialog: boolean;

    showArchiveSettingsDialog: boolean;
    autoArchiveDate: number | null;

    showRemindMeLaterSettingsDialog: boolean;
    remindMeLaterDate: RelativeDateTimeOption;

    manageBlockedImagesDialogOpen: boolean;
}

export const NoItemContent: ItemContent = {dummyType: "none"};
export const LoadingItemContent: ItemContent = {dummyType: "loading"};

export const initialItemState: ItemState = {
    emailHeaders: [],
    allEmailHeadersLoaded: false,
    itemLoadingInProgress: false,
    folderLoadingInProgress: false,
    draftEmailHeaders: [],

    mobileSelectionEnabled: false,

    selectedEmailHeaders: [],
    selectedOutgoingEmails: [],

    pendingSyncItems: [],

    availableCategories: [],
    selectedCategoriesFilter: [],

    contentExpanded: false,
    isLoadingContent: false,
    itemContentIndex: 0,
    itemContents: [NoItemContent, NoItemContent],

    emailViewOptions: EmailViewOptionsPref.get(),

    showEmailCategoryDialog: false,
    editEmailCategory: "",

    showArchiveSettingsDialog: false,
    autoArchiveDate: null,

    showRemindMeLaterSettingsDialog: false,
    remindMeLaterDate: undefined,

    manageBlockedImagesDialogOpen: false,
};

export function getItemContent(state: ItemState): ItemContent {
    return state.itemContents[state.itemContentIndex];
}

export function getOldItemContent(state: ItemState): ItemContent {
    return state.itemContents[state.itemContentIndex === 1 ? 0 : 1];
}
